import Menu from './Menu'
window.Menu = Menu
